// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"e6d93c03","469":"a4cd5493","679":"758c763e","986":"180ca553"}[chunkId] + ".chunk.css";
};